import {
  AccountGeneralPage,
  AccountSecurityPage,
  AccountIntegrationsPage,
  AccountNotificationsPage,
} from './imports';

export const accountSettingsRoutes = [
  {
    path: 'accounts',
    children: [
      { element: <AccountGeneralPage />, index: true },
      { path: 'general', element: <AccountGeneralPage /> },
      { path: 'security', element: <AccountSecurityPage /> },
      { path: 'notifications', element: <AccountNotificationsPage /> },
      { path: 'integrations', element: <AccountIntegrationsPage /> },
    ],
  },
];
